import * as types from "./ActionsWarehouseReducer";

export default function warehouseReducer(
    state = {
        warehouses: []
    }, action) {
    switch (action.type) {
        case types.GET_WAREHOUSES:
            state.warehouses = action.value;
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/warehouse/WarehouseReducer.ts